import darkTheme from '../DarkTheme'
import WebThemeInterface from './WebThemeInterface'

const breakpoints = ['320px', '652px', '810px', '1203px', '1596px', '1920px']

const webMediathekDarkTheme: WebThemeInterface = {
    ...darkTheme,
    breakpoints,
}

export default webMediathekDarkTheme
